export enum ApiEndpoints {
  editionStage = 'public/family-choice-path/edition-stage',
  provinces = 'public/family-choice-path/provinces',
  bubbles = 'public/family-choice-path/bubble/:provinceId',
  familiesList = 'public/family-choice-path/list/:bubbleId/:warehouseId/:categoryId/:isDifficult/:offset/:limit',
  details = 'public/family-choice-path/details/:familyEditionId/:warehouseId',
  giftgiver = 'public/family-choice-path/gift-giver/:familyEditionId/:warehouseId',
  giftgiver_categories = 'public/resource/gift-giver-categories',
  consent = 'public/consents/family_choice_path',
  filter_resource = 'public/resource/fcp/:bubbleId',
  families_amount = 'public/family-choice-path/number-of-families',
}
